import React from "react";
import { Helmet } from "react-helmet";
import { PropTypes } from "prop-types";

const Page = ({ title, children }) => (
  <div className="content">
    <Helmet>
      <title>Spawner | {title}</title>
    </Helmet>
    <div>{children}</div>
  </div>
);

Page.propTypes = {
  title: PropTypes.string.isRequired
};

export default Page;
